<template>
  <CRow>
    <CCol sm="12">

      <CCard>

        <CCardHeader>
          <CIcon name="cil-text"/>
          Neues Katalogmaterial anlegen
        </CCardHeader>

        <CCardBody>
          <ValidationObserver v-slot="{ invalid }">
            <CForm class="no-mb" @submit.prevent="newMaterial()">
              <MaterialText v-model="material" formLabel="Materialname" />
              <MaterialText v-model="artikelnr" formLabel="Artikelnummer" rules="" />
              <MaterialText v-model="herstellernummer" formLabel="Herstellernummer" rules="" />
              <MaterialText v-model="hersteller" formLabel="Hersteller" rules="" />
              <MaterialText v-model="stueck" formLabel="Standardmenge" />
              <MaterialText v-model="qtySuggestionsText" formLabel="Stückvorschläge" rules="" placeholder="z. B. 1, 2, 3, 5, 10" />

              <div v-if="qtySuggestionPreview.length > 0" class="qty-preview mb-3">
                <CButton
                  v-for="qty in qtySuggestionPreview"
                  :key="`qty-preview-${qty}`"
                  color="secondary"
                  variant="outline"
                  size="sm"
                  class="mr-1 mb-1"
                  disabled
                >
                  {{ formatQuantitySuggestionLabel(qty) }}
                </CButton>
              </div>

              <FormError v-if="formError" :errormessage="formError"/>

              <CRow class="mt-4">
                <CCol col="12" class="text-right">
                  <CButton color="primary" class="px-4" :disabled="invalid" type="submit">Material anlegen</CButton>
                </CCol>
              </CRow>

            </CForm>
          </ValidationObserver>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import FormError from '@/components/FormError'
import MaterialText from '@/components/FormElements/Text'

export default {
  name: 'MaterialNew',
  components: {
    FormError,
    MaterialText
  },
  data () {
    return {
      material: '',
      artikelnr: '',
      herstellernummer: '',
      hersteller: '',
      stueck: '1',
      qtySuggestionsText: '',
      formError: null
    }
  },
  computed: {
    qtySuggestionPreview () {
      return this.normalizeSuggestions(this.qtySuggestionsText)
    }
  },
  mounted () {
    this.setDefaults()
  },
  methods: {
    setDefaults () {
      this.material = ''
      this.artikelnr = ''
      this.herstellernummer = ''
      this.hersteller = ''
      this.stueck = '1'
      this.qtySuggestionsText = ''
      this.formError = null
    },
    newMaterial () {
      Vue.axios.post('/material/post', {
        material: this.material,
        artikelnr: this.artikelnr,
        herstellernummer: this.herstellernummer,
        hersteller: this.hersteller,
        stueck: this.stueck,
        qtysuggestions: this.qtySuggestionsText
      }).then((response) => {
        this.$router.push({ path: '/material/uebersicht' })
        this.$snotify.success('Das neue Katalogmaterial wurde angelegt.', {
          position: 'rightTop',
          timeout: 4000
        })
        this.setDefaults()
      }).catch((error) => {
        this.formError = error.response.data
      })
    },
    normalizeSuggestions (value) {
      return value
        .split(/[\n,;]+/)
        .map(item => item.trim())
        .filter(item => item !== '')
    },
    formatQuantitySuggestionLabel (quantity) {
      const normalizedQuantity = String(quantity || '').trim()
      return /^[-+]?\d+(?:[.,]\d+)?$/.test(normalizedQuantity) ? `${normalizedQuantity}x` : normalizedQuantity
    }
  }
}
</script>
